import React from 'react'

const Loader = () => {
    return (
        <>
            <div className='fade modal-backdrop show'></div>
            <div className="vw-100 vh-100 position-fixed top-0 start-0" style={{ zIndex: '1220' }}>
                <div
                    className="w-100 h-100 d-flex justify-content-center align-items-center position-relative"
                    style={{ zIndex: '1225' }}
                >
                    <span className="eye-loader"></span>
                </div>
            </div>
        </>
    )
}

export default Loader